
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"76","height":"77","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.94 68.961l-2.226-38a2.715 2.715 0 012.715-3.04h25.025a2.769 2.769 0 012.66 2.063l2.172 8.794H70.57a2.716 2.716 0 012.715 2.932l-2.117 27.143a5.429 5.429 0 01-5.429 4.994H10.369A5.428 5.428 0 014.94 68.96zM19 17.064V6.207a2.714 2.714 0 012.714-2.714h46.143a2.714 2.714 0 012.714 2.714v21.714","stroke":"#fff","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M40.714 17.064H57","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    